import React from 'react';
import Option from '../form/option';
interface Props
	extends React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableDataCellElement>, HTMLTableDataCellElement>,
		React.DetailedHTMLProps<React.ThHTMLAttributes<HTMLTableHeaderCellElement>, HTMLTableHeaderCellElement> {
	header?: boolean;
	onClick?: React.MouseEventHandler<any>;
	input?: boolean;
	dropDownOptions?: Array<{
		name: string;
		value: string;
	}>;
	inputValue?: string;
	placeholder?: string;
	inputLabel?: string;
	disabled?: boolean;
	onInputChange?: (text: string) => void;
}

const PbCell: React.FC<Props> = (props) => {
	let html: JSX.Element;
	const onChangeInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
		props.onInputChange && props.onInputChange(e.target.value);
	};
	if (props.header) {
		html = (
			<th className={`${props.className || ''}`} onClick={props.onClick} colSpan={props.colSpan} rowSpan={props.rowSpan} style={props.style}>
				{typeof props.children === 'string' ? props.children : props.children}
			</th>
		);
	} else if (props.input) {
		html = (
			<td className={props.className} rowSpan={props.rowSpan} colSpan={props.colSpan} style={props.style}>
				{props.inputLabel ? <label className='mb-3'>{props.inputLabel}</label> : ''}
				{props.dropDownOptions ? (
					<select
						area-placeholder={props.placeholder || ''}
						className='form-control'
						value={props.inputValue}
						onChange={onChangeInput}
						disabled={props.disabled}
					>
						{props.dropDownOptions.map((option) => (
							<Option id={''} key={option.name} {...option} />
						))}
					</select>
				) : (
					<input value={props.inputValue || ''} onChange={onChangeInput} className='form-control' placeholder={props.placeholder || ''} />
				)}
			</td>
		);
	} else {
		html = (
			<td
				className={[props.className, 'Cell'].join(' ')}
				colSpan={props.colSpan}
				rowSpan={props.rowSpan}
				style={props.style}
				onClick={props.onClick}
			>
				{props.children}
			</td>
		);
	}

	return html;
};
export default PbCell;
